module.exports = __webpack_public_path__ + "img/0.885b8b4d.png";